import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useProduct from "../../hooks/useProduct";
import { Tab, Row, Col, Nav } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import CardProducto from "../../components/products/CardProducto";
import DownloadIcon from "@mui/icons-material/Download";
import usePgiModules from "../../hooks/useModules";
import BannerPub from "../../components/BannerPub";
import images from "../../exports/images";
import CarouselMobile from "../../components/carousel/CarouselMobile";
import CarouselMobileProdEspeciales from "../../components/carousel/CarouselMobileProdEspeciales";
import ModuleBlockNews from "../../components/news/ModuleBlockNews";
import { isVideov2 } from "../../helpers/isVideo";
import { URLDefaultLogoTensolite } from "../../helpers/constants";
import { formatDescription } from "../../helpers/functions";

const isSubProductPage = true;

const DetalleProducto = () => {
  const { product, subProduct, getProductsByBody, getDetalleProductoByParams } = useProduct();
  const params = useParams();
  const [homeModules, setHomeModules] = useState([]);
  const { getModulesByParams } = usePgiModules();
  let descargasVisibles;

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setHomeModules(res.sort((a, b) => a.position - b.position));
    });
  }, []);

  descargasVisibles = product?.filename?.filter(
    (item) => item.state === true && item.deleted !== true
  );

  useEffect(() => {
    getDetalleProductoByParams(params.id?.replaceAll("-", " ").toLowerCase());
  }, []);

  useEffect(() => {
    if (subProduct?.productTitle) {
      getProductsByBody({ title: subProduct?.productTitle });
    }
  }, [subProduct]);

  const newArraySubProduct = subProduct?.groupByCategory?.filter(
    (subprod) =>
      subprod.deleted === false && subprod.state === true && subProduct?._id !== subprod._id
  );
  const titlePageSubProduct = (product, subProduct) => {
    switch (product?.title) {
      case "TENSOBLOCK":
        return `${product?.title} - ${subProduct?.title} de hormigón para muros y cerramientos`;
      case "TENSOQUINES":
        return `${product?.title} - ${subProduct?.title} de hormigón`;
      case "BOVEDILLA":
        return `${product?.title} ${subProduct?.title} - Bovedillas EPS y de hormigón para losas`;
      case "POSTES P10":
        return `${product?.title} ${subProduct?.title} - Postes de hormigón para cercados`;
        case "TEJALITE":
        return `${product?.title} ${subProduct?.title} - Tejas de hormigón de diferentes colores`;
      default:
        return "Tensolite";
    }
  }
  console.log(product)
  return (
    <> 
    <HelmetProvider>
        <Helmet prioritizeSeoTags>
            <title>{titlePageSubProduct(product, subProduct)}</title>
            <meta name="title" content={titlePageSubProduct(product, subProduct)}/>
          <meta name="description" content={product?.top_mobile && product?.top_mobile?.length > 0 ? product.top_mobile : formatDescription(product?.top) } />

          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content={`https://tensolite.com`}
          />
          <meta property="og:title" content={titlePageSubProduct(product, subProduct)} />
          <meta property="og:description" content={`${product?.top}`} />
          <meta property="og:image" content={`${URLDefaultLogoTensolite}`} />
          
          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content={`https://tensolite.com`}
          />
          <meta property="twitter:title" content={titlePageSubProduct(product, subProduct)} />
          <meta property="twitter:description" content={`${product?.top}`} />
          <meta property="twitter:image" content={`${URLDefaultLogoTensolite}`} />
        </Helmet>
      </HelmetProvider>
    {titlePageSubProduct(product, subProduct)}
      <section className="container" id="detalleProducts__detalleP">
        <div className="row">
          {/* bloq de imagen 3d*/}
          <div className="col-sm-12 col-md-6 col-lg-6" id="detalleProducts__img-p">
            <picture className="mt-3">
              {isVideov2(subProduct?.imageProduct ? subProduct?.imageProduct?.[0]?.url : "") ? (
                <video
                  src={subProduct?.imageProduct ? subProduct?.imageProduct?.[0]?.url : ""}
                  controls
                  className="mt-3"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              ) : (
                <>
                  <source
                    className={`${subProduct.imageProduct_webp} ? 'mt-3' : ''`}
                    media="(min-width: 768px)"
                    srcSet={
                      subProduct.imageProduct_webp
                        ? subProduct.imageProduct_webp[1]?.url
                        : subProduct.imageProduct_webp
                    }
                    alt={subProduct.title}
                    title={subProduct.title}
                  />
                  <img
                    className="mt-3"
                    src={subProduct?.imageProduct?.[0]?.url}
                    alt={subProduct.title}
                    title={subProduct.title}
                    loading="lazy"
                  />
                </>
              )}
            </picture>
          </div>
          <article className="col-sm-12 col-md-6 col-lg-6 mt-3" id="detalleProducts__portada">
            <header className="detalleProducts__portada">
              <div className="header-product">
                <h2 className="categoria">{subProduct?.subCategory}</h2>
                <div role="img" aria-label={subProduct?.category} className="brand-product">
                  <img
                    src={subProduct?.imageLogo?.[0]?.url}
                    alt={subProduct?.category}
                    title={subProduct?.category}
                    loading="lazy"
                  />
                </div>
              </div>
              <h1 className="title">{subProduct?.title}</h1>
            </header>
            <p>{subProduct?.description}</p>

            <div className="detalleProducts__dimensiones">
              <p>
                <span className="text-bold">Dimensiones:</span> {subProduct?.dimension} cm
              </p>
              <p>
                <span className="text-bold">Cantidad:</span> {subProduct?.quantity}
              </p>
              <p>
                <span className="text-bold">Peso:</span> {subProduct?.weight} kg
              </p>
            </div>
          </article>
        </div>
        {/* fin bloq superior*/}
        <section id="detalleProducts__bloq-inferior">
          {/* Bloq inferior*/}
          <article className="col-12 col-md-8 col-sm-12">
            <p className="detalleProducts__destacado">{subProduct?.subdescription}</p>
            <div role="presentation" id="caracteristicas-product">
              {/*  Nav tabs */}
              <Tab.Container defaultActiveKey="first">
                <Row className="mt-4">
                  <Col sm={3}>
                    <Nav variant="pills" className="flex-column">
                      {subProduct?.tabs?.map((tab) => (
                        <Nav.Item>
                          <Nav.Link eventKey={tab.id}>{tab.title}</Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </Col>
                  <Col sm={9}>
                    <Tab.Content className="mb-5">
                      {subProduct?.tabs?.map((tab) => (
                        <Tab.Pane
                          id=""
                          eventKey={tab.id}
                          className="tab_description--container"
                          dangerouslySetInnerHTML={{ __html: tab.description }}
                        ></Tab.Pane>
                      ))}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </article>
          <div role="presentation" className="col-4 settings__col-buttons button-products">
            <div
              className={`width-50 ${descargasVisibles === undefined || descargasVisibles?.length === 0
                ? "d-none"
                : "width-100"
                }`}
            >
              <h3>Descargas</h3>
              <ul className="settings__lista-descargas">
                {product?.filename?.map(
                  (item, index) =>
                    item.state === true &&
                    item.deleted === false && (
                      <li key={index}>
                        <DownloadIcon />
                        <a
                          href={item?.url}
                          target="_blank"
                          rel="noreferrer noopener"
                          title={`Descargar ${item.filename}`}
                        >
                          {item?.title}
                        </a>
                      </li>
                    )
                )}
              </ul>
            </div>
          </div>
        </section>
      </section>
      {homeModules.map((item, index) => {
        switch (item.title) {
          case "Banner_publicitario":
            if (item.visible.includes(`${subProduct._id}`)) {
              return (
                <>
                  <BannerPub idProducto={subProduct._id} />
                </>
              );
            }
            break;
          case "Bloque_info":
            if (item.visible.includes(`${subProduct._id}`)) {
              return <ModuleBlockNews key={index} idProducto={subProduct._id} />;
            }
            break;
          default:
        }
      })}
      {newArraySubProduct?.length > 0 && (
        <aside id="mod_product-linea" className="base__bg-grey_3">
          <div className="container detalleProduct__mod-product">
            <h3>Otros productos de la categoría {subProduct?.category}</h3>
            {newArraySubProduct?.map((prod) =>
              prod?.deleted === false && prod?.visible === true ? (
                <CardProducto key={prod._id} producto={prod} />
              ) : (
                ""
              )
            )}
          </div>
        </aside>
      )}
      {homeModules.map((item, index) => {
        switch (item.title) {
          case "Carrousel_deLinea":
            if (item.visible.includes(`${subProduct._id}`)) {
              return (
                <div key={index} className="container producto-linea">
                  <CarouselMobile
                    isSubProductPage={isSubProductPage}
                    currentProduct={product}
                    images={images[0]}
                  />
                </div>
              );
            }
            break;
          case "Carrousel_especial":
            if (item.visible.includes(`${subProduct._id}`)) {
              return (
                <div key={index} className="container producto-linea mb-5">
                  <CarouselMobileProdEspeciales
                    isSubProductPage={isSubProductPage}
                    currentProduct={product}
                    images={images[1]}
                  />
                </div>
              );
            }
            break;
          default:
        }
        return null;
      })}
    </>
  );
};

export default DetalleProducto;
